import React from "react";
import { useSurveyQuestion } from "../use_survey_question";
import { Survey } from "../../../generated/graphql";
import { SurveyAudienceContext } from "../../survey_page";

const TRUNCATE_LIMIT = 150;

const trailingEllipsis = (str: string) => {
  return str.length > TRUNCATE_LIMIT ? "..." : "";
};

export default function QuestionErrorItem({
  question,
  surveyAudienceContext,
}: {
  question: Survey["questions"]["0"];
  // This is only needed because of the rotatingCareerOpenResponse question, which
  // hard codes the list of question in the FE and uses this object to determine which questions are
  // available to the user. All other questions have this information stored in the metadata of the
  // customizations column. A plague on the house of rotatingCareerOpenResponse.
  surveyAudienceContext?: SurveyAudienceContext;
}) {
  const { getQuestionLabel } = useSurveyQuestion(question, surveyAudienceContext);

  // TODO: enable click to scroll
  //   const handleScrollToQuestion = () => {
  //     const element = document.getElementById(question.id);
  //     element?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  //   };

  return (
    <li
      // onClick functionality to scroll to the question with an error will be worked on in TA-923
      // onClick={handleScrollToQuestion}
      data-test={`question-error-message`}
    >
      {getQuestionLabel().substring(0, TRUNCATE_LIMIT)}
      {trailingEllipsis(getQuestionLabel())}
    </li>
  );
}
